import { protectedRoute } from "@/utils/routeUtils";

const allowedRoles = ["SUPER_ADMIN", "MANAGER", "OFFICER"];

const billingSetupRoutes = {
  path: "billing-setup",
  title: "module_title.billing_setup",
  sidebarProps: {
    key: "2-4",
    iconSrc: "card",
    label: "module_title.billing_setup",
    link: "/billing-setup",
    groupingType: "SETTINGS",
    order: 4,
    permissions: allowedRoles,
  },
  element: protectedRoute(
    [() => import("@/pages/billing-setup/BillingSetup")],
    allowedRoles
  ),
};

export default billingSetupRoutes;
